module.exports = __webpack_public_path__ + "img/depeche_mode.2c6c68c3.jpg";